import React from "react";

import sampleActions from "../../flux/actions/SampleActions";

import * as CONSTANTS from "../../utilities/Constants";

import "./sample.sass";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";

import { Translation } from "react-i18next";
import { Button, LoadingIndicator, Pagination } from "@abb/abb-common-ux-react";
import ReportHeader from "./ReportHeader";
import ReportTable from "./ReportTable";
import sampleValueReportStore from "../../flux/stores/sample/ValueReportStore";
import IReportProperties, {
  defaultReportProperties,
} from "../../models/sample/ReportProperties";
import ReactToPrint from "react-to-print";
import settingsActions from "../../flux/actions/SettingsAction";
import {
  defaultMeasurementSettingData,
  MeasurementSetting,
} from "../../models/settings/MeasurementSettings";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import triggerNotifications from "../../utilities/TriggerNotifications";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import moment from "moment";
import sampleByIdStore from "../../flux/stores/sample/ByIdStore";
import DateFormatting from "../../utilities/DateFormat";
interface IIndexState {
  sampleId: string;
  sampleData: any;
  reportData: IReportProperties;
  leftList: any[];
  rightList: any[];
  page: number;
  size: number;
  isPrintClicked: boolean;
  settings: MeasurementSetting;
  reportDate: any;
  thresholdSettings: IThresholdSettings[];
  loadingReport: boolean;
}

export default class ReportSample extends React.Component<
  { location: any },
  IIndexState
> {
  private _mount = false;

  _columnsLeft: IColumnHeaderData[];
  _columnsRight: IColumnHeaderData[];
  private _reportData: IReportProperties;
  componentRef: any;
  private _settingsData: MeasurementSetting;
  private _thresholdSettings: IThresholdSettings[];
  private _reportType: any;
  private _sampleId: any;

  constructor(props: { location: any }) {
    super(props);
    this._mount = false;
    console.log("took the bait");
    const sampleData = {};
    const urlPath = this.props.location.pathname.split("/");
    this._reportType = urlPath[3];
    this._sampleId = urlPath[4];

    this.state = {
      sampleId: "",
      sampleData,
      reportData: defaultReportProperties,
      leftList: [],
      rightList: [],
      page: 0,
      size: 2,
      isPrintClicked: false,
      settings: defaultMeasurementSettingData,
      reportDate: new Date().toLocaleString(),
      thresholdSettings: [],
      loadingReport: false,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
    
      this.setState({
        reportDate: moment
          .utc(new Date())
          .utcOffset(DateFormatting.getDateTimeRegionOffset())
          .format(DateFormatting.getDateTimeRegion()),
      });
    sampleByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {

        const sampleData = {
          description: state.sampleData.description,
          formatedDate: state.sampleData.formatedDate,
          id: state.sampleData.id,
          isEditMode: true,
          name: state.sampleData.name,
          orderId: state.sampleData?.orderId,
          productId: state.sampleData.product?.id,
          productName: state.sampleData.product?.name,
          reportType: this._reportType,
          requestId: CONSTANTS.DefaultGuid,
          sampleDate: state.sampleData?.sampleDate,
          setId: state.sampleData?.setId,
          sourceId: state.sampleData.source?.id,
          sourceName: state.sampleData.source?.name,
        };
        this.setState({
          sampleData: sampleData,
        });
      }
    });

    sampleActions.getById(this._sampleId).then(() => {
      let module:string = "";

      if (this.state.sampleData.reportType === CONSTANTS.VALUE_REPORT) {
        module = CONSTANTS.VALUE_REPORT;
        this.setState({ size: 1 });
      } else if (this.state.sampleData.reportType === CONSTANTS.REEL_REPORT) {
        module = CONSTANTS.REEL_REPORT;
        this.setState({ size: 10 });
      } else if (
        this.state.sampleData.reportType === CONSTANTS.POSITION_REPORT
      ) {
        module = CONSTANTS.POSITION_REPORT;
        this.setState({ size: 10 });
      } else {
        module = CONSTANTS.GRAPH_REPORT;
        this.setState({ size: 10 });
      }

      sampleValueReportStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
        if (this._mount) {
          this._reportData = state.reportData;
        }
      });

      measurementSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
        if (this._mount) {
          this._settingsData = state.data;
        }
      });

      thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
        if (this._mount) {
          this._thresholdSettings = state.data;
        }
      });

      this.getValueReport();
      this.getGeneralSettings();
      this.getThresholdValues();
    });
  }

  private getValueReport = () => {
    this.setState({
      loadingReport: true,
    });
    let hasProduct = this.state.sampleData?.product? true:false;
    sampleActions
      .getValueReport(this.state.sampleData.id,hasProduct)
      .then(() => {
        this.setState({ reportData: this._reportData, loadingReport: false });
      })
      .catch((error) => {
        this.setState({ reportData: this._reportData, loadingReport: false });
      });
  };

  private getThresholdValues = () => {
    settingsActions
      .getThresholdReport()
      .then(() => {
        this.setState({
          thresholdSettings: this._thresholdSettings,
        });
      })
      .catch((e) => {
        triggerNotifications.error(e);
      });
  };

  private getGeneralSettings = () => {
    settingsActions
      .getGeneral()
      .then(() => {
        this.setState({
          settings: this._settingsData,
        });
      })
      .catch((e) => {
        triggerNotifications.error(e);
      });
  };

  private onPrintClick = () => {
    return new Promise<void>((resolve, reject) => {
      let fileName = "";
      if (this.state.settings.fileNamePrefix) {
        fileName += this.state.settings.fileNamePrefix + "_";
      }
      fileName +=
        this.state.sampleData.name +
        "_" +
        this.state.sampleData.reportType +
        "_" +
        moment(new Date()).format("DDMMYYYY");
      window.document.title = fileName;
      this.setState({ isPrintClicked: true }, () => resolve());
    });
  };

  private onAfterPrint = () => {
    return new Promise<void>((resolve, reject) => {
      window.document.title = CONSTANTS.PRODUCT_NAME;
      this.setState({ isPrintClicked: false }, () => resolve());
    });
  };

  public render() {
    const columns = [
      { path: "name", name: "Property Name", type: "string" },
      { path: "unit", name: "Unit", type: "string" },
      { path: "mean", name: "Mean", type: "number" },
      { path: "stdDev", name: "Std Dev", type: "number" },
      { path: "min", name: "Min", type: "number" },
      { path: "max", name: "Max", type: "number" },
      { path: "ok", name: "OK", type: "string" },
      { path: "reject", name: "Reject", type: "string" },
      { path: "alarm1", name: "Alarm1", type: "number" },
      { path: "alarm2", name: "Alarm2", type: "number" }
    ];

    const data = [
      ...this.state?.reportData?.properties?.slice(
        this.state.page * this.state.size,
        (this.state.page + 1) * this.state.size
      ),
    ];

    const internalColumns = [
      { path: "positionName", name: "Position", type: "string" },
      { path: "positionMean", name: "Pos. Mean", type: "number" },
    ];

    return (
      <Translation>
        {(t) => (
          <div className="page-scroll" style={{ zIndex: 9999 }}>
            <div className="row mt-3 align-self-center rounded-sm rounded-lg">
              <div className="col-md-12">
                <div className="mx-5 mb-3 bg-white">
                  <div className="float-right">
                    <ReactToPrint
                      onBeforeGetContent={this.onPrintClick}
                      onAfterPrint={this.onAfterPrint}
                      // tslint:disable-next-line: jsx-no-lambda
                      trigger={() => (
                        <Button
                          icon="abb/print"
                          sizeClass="small"
                          text={t("Print")}
                          type="discreet-blue"
                        />
                      )}
                      // tslint:disable-next-line: jsx-no-lambda
                      content={() => this.componentRef}
                    />
                  </div>
                  <div className="clearfix" />
                  <hr className="hr-line" />

                  {this.state.loadingReport ? (
                    <LoadingIndicator
                      determinate={false}
                      type="radial"
                      color="blue"
                      style={{ margin: "0px auto" }}
                      sizeClass="medium"
                    />
                  ) : (
                    <div
                      className="report-container"
                      ref={(el) => (this.componentRef = el)}
                    >
                      {this.state.isPrintClicked ? (
                        <table>
                          <thead style={{ width: "100%" }}>
                            <tr>
                              <td>
                                {this.state.isPrintClicked &&
                                this.state.settings.header
                                  ? this.state.settings.header
                                  : null}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {this.state.isPrintClicked &&
                                this.state.settings.subHeader
                                  ? this.state.settings.subHeader
                                  : null}
                              </td>
                            </tr>
                            <tr>
                              <ReportHeader
                                sampleData={this.state?.sampleData}
                                reportDate={this.state.reportDate}
                                thresholdSettings={this.state.thresholdSettings}
                              />
                            </tr>
                          </thead>
                          <ReportTable
                            sampleData={this.state.sampleData}
                            columns={columns}
                            data={
                              this.state.isPrintClicked
                                ? this.state?.reportData?.properties
                                : data
                            }
                            internalColumns={internalColumns}
                            isPrintClicked={this.state.isPrintClicked}
                            thresholdSettings={this.state.thresholdSettings}
                            settings={this.state.settings}
                          />
                          <tfoot style={{ position: "fixed", bottom: 0 }}>
                            <tr>{this.state.settings.footer}</tr>
                          </tfoot>
                        </table>
                      ) : null}

                      <div className="report-menu-header">
                        {!this.state.isPrintClicked ? (
                          <ReportHeader
                            sampleData={this.state?.sampleData}
                            reportDate={this.state.reportDate}
                            thresholdSettings={this.state.thresholdSettings}
                          />
                        ) : null}
                      </div>
                      <div className="header-padding">
                        {!this.state.isPrintClicked ? (
                          <ReportTable
                            sampleData={this.state.sampleData}
                            columns={columns}
                            data={
                              this.state.isPrintClicked
                                ? this.state?.reportData?.properties
                                : data
                            }
                            internalColumns={internalColumns}
                            isPrintClicked={this.state.isPrintClicked}
                            thresholdSettings={this.state.thresholdSettings}
                            settings={this.state.settings}
                          />
                        ) : null}

                        {!this.state.isPrintClicked ? (
                          <Pagination
                            showPageSelectionInput={false}
                            onGotoPage={(v) => this.goPage(v)}
                            onSetPageSize={(v) => this.setSize(v)}
                            currentPage={this.state.page}
                            currentPageSize={this.state.size}
                            rowCount={this.state?.reportData?.properties.length}
                            showPrevNext={true}
                            showNumberButtons={true}
                            showInput={true}
                            pageSizeOptions={[1, 2, 3, 5, 10]}
                          />
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  goPage = (v: number) => {
    this.setState({ page: v });
  };

  setSize = (v: number) => {
    this.setState({ size: v });
  };
}
